



















import VehicleCard from './VehicleCard.vue';
import Component from 'vue-class-component';
import {Prop, Vue} from 'vue-property-decorator';
import {IVehicle} from '@/models/Vehicle';
import {konsole} from '@/services/Konsole';
import {library} from '@fortawesome/fontawesome-svg-core';
import {faSearch} from '@fortawesome/pro-solid-svg-icons';
import VehicleRowItem from '@/components/VehicleRowItem.vue';

@Component({
  components: {VehicleRowItem, VehicleCard},
})
export default class VehicleList extends Vue {
  @Prop() public vehicles: IVehicle[];
  @Prop() public view: 'list' | 'grid';

  constructor() {
    super();
    library.add(faSearch);
    // konsole.init('New instance of VehicleList');
  }
}
